/**
 * Billing hand-off notices (suite contract 1.2). A failed hand-off to Central's
 * billing is never silent and never a raw error string: it says what happened
 * and offers the Central billing page as a fallback link.
 */

import toast from 'react-hot-toast';
import { ASK_OWNER_BILLING_COPY } from '../../adapters/settingsAdapter';
import { markCentralBillingOpened } from '../../services/centralBillingUrls';

/** "Couldn't open billing" + a link to Central's billing page when one is known. */
export function showBillingFallbackToast(fallbackUrl: string | null): void {
  toast.error(
    () => (
      <span data-testid="billing-fallback-toast">
        We couldn&apos;t open billing just now.{' '}
        {fallbackUrl ? (
          <a
            href={fallbackUrl}
            onClick={() => markCentralBillingOpened()}
            className="underline font-medium"
            data-testid="billing-fallback-link"
          >
            Open billing in LevelUp
          </a>
        ) : (
          'Please try again shortly.'
        )}
      </span>
    ),
    { id: 'billing-fallback', duration: 8000 },
  );
}

/** A member asked for a billing action they cannot take. */
export function showAskOwnerToast(): void {
  toast(ASK_OWNER_BILLING_COPY, { id: 'billing-ask-owner', duration: 6000 });
}
